import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "../fonts/breuer-headline.css";
import "./house.css";
import { setBackButtonUrl } from "../uiSlice";
import { getHouseById } from "./housesConfig";
import startBtnImg from "../images/next.png";

const HOGWARTS_SELECTION_KEY_BASE = "hogwartsSelectionData";

function readStoredUserData() {
  try {
    const raw =
      localStorage.getItem("userData") ||
      sessionStorage.getItem("userData") ||
      "{}";
    return JSON.parse(raw) || {};
  } catch {
    return {};
  }
}

function getSelectionStorageKey(userLike) {
  const stored = readStoredUserData();
  const uid = userLike?.userId ?? userLike?.userid ?? userLike?.id ?? stored?.userId ?? stored?.userid ?? stored?.id;
  const sid = userLike?.sessionId ?? stored?.sessionId;
  const oid = userLike?.organizationId ?? stored?.organizationId;
  const scope = [uid, sid, oid]
    .map((v) => String(v ?? "").trim())
    .join(":");
  return scope.replace(/:/g, "") ? `${HOGWARTS_SELECTION_KEY_BASE}:${scope}` : HOGWARTS_SELECTION_KEY_BASE;
}

function readSelectionArray(userLike) {
  try {
    const raw = localStorage.getItem(getSelectionStorageKey(userLike));
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function findSelectionEntry(type, userLike) {
  return readSelectionArray(userLike).find((item) => item?.type === type) ?? null;
}

function upsertSelectionEntry(type, value, userLike) {
  const current = readSelectionArray(userLike);
  const filtered = current.filter((item) => item?.type !== type);
  filtered.push({ type, ...value });
  try {
    localStorage.setItem(getSelectionStorageKey(userLike), JSON.stringify(filtered));
  } catch {
    // ignore storage write failures
  }
}

function House() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { status, user } = useSelector((state) => state.auth);
  const selectedHouse = findSelectionEntry("house", user);
  const houseId = location.state?.houseId ?? selectedHouse?.houseId;
  const house = houseId ? getHouseById(houseId) : null;
  const [animationComplete, setAnimationComplete] = useState(false);

  useEffect(() => {
    document.documentElement.classList.add("house-static-bg");
    document.body.classList.add("house-static-bg");
    return () => {
      document.documentElement.classList.remove("house-static-bg");
      document.body.classList.remove("house-static-bg");
    };
  }, []);

  useEffect(() => {
    dispatch(setBackButtonUrl("/house"));
  }, [dispatch, status, user]);

  useEffect(() => {
    if (!house) return;
    upsertSelectionEntry("house", {
      houseId: house.id,
      houseName: house.name,
    }, user);
  }, [house, user]);

  // Set animation complete after slower logo animation duration (1.2s)
  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimationComplete(true);
    }, 1200);
    return () => clearTimeout(timer);
  }, []);

  const handleNextClick = () => {
    navigate("/character", { state: { houseId: house.id } });
  };

  if (!house) {
    return <Navigate to="/sorthat" replace />;
  }

  return (
    <div className="house-page">
      <div className="house-stack">
        <div className="house-crest-wrap">
          <img
            src={house.logo}
            className={`house-crest ${!animationComplete ? "glowing" : ""}`}
            alt={`${house.name} crest`}
          />
        </div>

        <div className={`house-content ${animationComplete ? "visible" : "hidden"}`}>
          <p className="house-motto">{house.motto}</p>
          <div className="house-scroll">
            <p className="house-scroll-intro">{house.title}</p>
          </div>
          <button
            type="button"
            className="house-next-btn"
            onClick={handleNextClick}
          >
            <img src={startBtnImg} alt="Next" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default House;